import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { suspenseOptions } from "@/lib/suspense-query";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { getGetStockOrderQueryOptions } from "@/requests/gen/react-query/stock-order";
import StockOrderCreateForm from "../-form";
import { StockOrderCrumbs } from "../-crumbs";

export const Route = createFileRoute(
  "/_private/_stock-360/stock-order/$stockOrderId/edit",
)({
  loader: ({ context: { queryClient }, params: { stockOrderId } }) =>
    queryClient.ensureQueryData(getGetStockOrderQueryOptions(stockOrderId)),
  component: StockOrderEditPage,
});

function StockOrderEditPage() {
  const { stockOrderId } = Route.useParams();
  const { data: stock_order } = useSuspenseQuery(
    suspenseOptions(getGetStockOrderQueryOptions(stockOrderId)),
  );

  return (
    <div>
      <title>
        {`Edit Stock Order ${stockOrderId} - Legrande Health Portal`}
      </title>
      <StockOrderCrumbs canEdit={true} />

      <Card>
        <CardHeader>
          <CardTitle>Edit Stock Order</CardTitle>
          <CardDescription>
            Select the approving entity and fulfiller for this order.
          </CardDescription>
        </CardHeader>
        <CardContent>
          {stock_order && <StockOrderCreateForm stock_order={stock_order} />}
        </CardContent>
      </Card>
    </div>
  );
}
